module.exports = __webpack_public_path__ + "static/media/anc8ru.d7061571.pdf";